export class Access {
    accessId?: string;
    accessRecipientId: string;
    userType: string;
    isNewAccess: boolean;
    isRole: boolean;
    roleId?: string;
    permissions?: number[];

    public constructor(
      accessId: string, accessRecipientId: string, userType: string, isNewAccess: boolean, isRole: boolean,
      permissionsOrRoleId: number[] | string);

    public constructor(accessRecipientId: string, userType: string, isNewAccess: boolean,
                     isRole: boolean, permissionsOrRoleId: number[] | string);
    constructor(...arr: any[]) {
      if(arr.length === 6) {
        this.accessId = arr[0];
        this.accessRecipientId = arr[1];
        this.userType = arr[2];
        this.isNewAccess = arr[3];
        this.isRole = arr[4];
        if(arr[5] instanceof Array) {
          this.permissions = arr[5];
        } else {
          this.roleId = arr[5];
          this.permissions = [];
        }
      } else {
        this.accessRecipientId = arr[0];
        this.userType = arr[1];
        this.isNewAccess = arr[2];
        this.isRole = arr[3];
        if(arr[4] instanceof Array) {
          this.permissions = arr[4];
        } else {
          this.roleId = arr[4];
          this.permissions = [];
        }
      }
    }
}
